<template>
    <div class="upload-picture-modal">
        <b-modal
                id="user-guide"
                title="User Guide"
                :size="getModalClass"
                :click-to-close="false"
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
        >
            <!--<div class="">-->
                <!--<b-carousel id="carousel" :interval="0" controls @sliding-end="onSlideEnd">-->
                    <!--<b-carousel-slide v-for="(iframe, index) in iframes" :key="index">-->
                        <!--<label>{{iframe.label}}</label>-->
                        <!--<iframe :src="iframe.url" width="100%" height="315px" frameborder="0" allowfullscreen ref="iframeRef"></iframe>-->
                    <!--</b-carousel-slide>-->
                <!--</b-carousel>-->
            <!--</div>-->

            <div class="row">
                <div class="col-md-9">
                    <div class="iframe-section">
                        <iframe :src="currentSrc" width="100%" height="520" frameborder="0" allowfullscreen ref="iframeRef"></iframe>
                        <label class = "mt-1 ml-2">{{currentLabel}}</label>
                    </div>
                </div>

                <div class="col-md-3 margin-custom vertical-separator">
                    <div class="row mb-2" v-for="(iframe, index) in iframes" :key="index">
                        <div class="col-sm-12" :class="{ 'selectedVideo': selectedIndex === index }">
                        <span class="">
                            <a @click="changeVideo(index)">
                                <img :src="iframe.thumbnail" style="height: 80px;"/>
                                <label class = "mt-1 ml-2">{{iframe.label}}</label>
                            </a>
                        </span>
                        </div>
                    </div>
                </div>
            </div>
            <!--<div v-else class="row">-->
                <!--<div class="col-sm-12">-->
                    <!--<p>Kindly click the download button.</p>-->
                <!--</div>-->
            <!--</div>-->
            <template #modal-footer="{}">
                <b-button size="sm" variant="primary" >
                    <a style="color: white;text-decoration: none" :href="FILE_URL" target="_blank" download>Download Manual</a>
                </b-button>
            </template>

        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        // props: {
        //     item: {
        //         type: Object,
        //         default: null,
        //     },
        // }, // End of Component > props
        computed: {
            ...mapGetters([
                'user'
            ]),
            getModalClass()
            {
                this.changeItems()
                // return this.user.accountType=='lite' ? 'sm' : 'lg'
            }
        }, // End of Component > computed
        methods: {
            changeVideo(index)
            {
                this.currentSrc=this.iframes[index].url
                this.currentLabel=this.iframes[index].label
                this.selectedIndex = index
            },
            onSlideEnd(index) {
                // Pause the video when the carousel slide changes
                const iframe = this.$refs.iframeRef[index];
                if (iframe && iframe.contentWindow) {
                    iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                }
            },
            changeItems()
            {
                if(this.user.accountType=='lite')
                {
                    this.FILE_URL=process.env.VUE_APP_URL+'api/files/users/user-manual-lite.pdf'
                    this.currentSrc= "https://www.idenfodirect.com/wp-content/uploads/2024/03/Onboarding-Video-Explainer.mp4"
                    this.currentLabel="Getting Started"
                    this.iframes= [
                    {
                        thumbnail:process.env.VUE_APP_URL+'api/files/logo/thumbnail1.png',
                        url: 'https://www.idenfodirect.com/wp-content/uploads/2024/03/Onboarding-Video-Explainer.mp4',
                        label:"Getting Started"
                    },
                    {
                        thumbnail:process.env.VUE_APP_URL+'api/files/logo/thumbnail2.png',
                        url: 'https://www.idenfodirect.com/wp-content/uploads/2024/03/Idenfo-Video2.mp4',
                        label:"How to onboard customers"
                    },
                    {
                        thumbnail:process.env.VUE_APP_URL+'api/files/logo/thumbnail3.png',
                        url: 'https://www.idenfodirect.com/wp-content/uploads/2024/03/Idenfo-Video3.mp4',
                        label:"Platform features"
                    },
                    {
                        thumbnail:process.env.VUE_APP_URL+'api/files/logo/thumbnail4.png',
                        url: 'https://www.idenfodirect.com/wp-content/uploads/2024/03/Idenfo-Video4_1.mp4',
                        label:"Configurations, team members and system logs"
                    },
                ]
                }
            }
        },
        data() {
            return {
                selectedIndex : 0,
                FILE_URL:process.env.VUE_APP_URL+'api/files/users/user-manual.pdf',
                currentSrc: "https://www.idenfodirect.com/wp-content/uploads/2024/03/Video-1.mp4",
                currentLabel:"Getting Started",
                iframes: [
                    {
                        thumbnail:process.env.VUE_APP_URL+'api/files/logo/thumbnail1.png',
                        url: 'https://www.idenfodirect.com/wp-content/uploads/2024/03/Video-1.mp4',
                        label:"Getting Started"
                    },
                    {
                        thumbnail:process.env.VUE_APP_URL+'api/files/logo/thumbnail2.png',
                        url: 'https://www.idenfodirect.com/wp-content/uploads/2024/03/Video-2.mp4',
                        label:"How to onboard customers"
                    },
                    {
                        thumbnail:process.env.VUE_APP_URL+'api/files/logo/thumbnail3.png',
                        url: 'https://www.idenfodirect.com/wp-content/uploads/2024/03/Video-3.mp4',
                        label:"Platform features"
                    },
                    {
                        thumbnail:process.env.VUE_APP_URL+'api/files/logo/thumbnail4.png',
                        url: 'https://www.idenfodirect.com/wp-content/uploads/2024/03/Idenfo-Video4.mp4',
                        label:"Configurations, team members and system logs"
                    },
                ],
            };
        },

    }
</script>
<style>
    .guide-link
    {
        color: #000;
        text-decoration: none;
    }
    .carousel-caption
    {
        position: initial !important;
    }
    .carousel-control-next, .carousel-control-prev
    {
        height: 100px !important;
        top: 121px !important;
    }
    .selectedVideo {
        border-right: 1px solid #ccc;
        padding-right: 30px!important;
    }
    .vertical-separator {
        border-left: 1px solid #ccc; /* Adjust border color and style as needed */
        height: 100%; /* Adjust the height to match the height of the items */
        /*margin-right: 10px; !* Adjust the margin to control the spacing between items *!*/
    }
    .margin-custom {
        /*margin-top: 32px;*/
        /*overflow-y: scroll;*/
    }
    .iframe-section {
        padding: 0;
    }
</style>
